<template>
  <span class="filter-date-range" v-bind:class="cssClass">
    <div class="filter-date-range-label">{{ label }}</div>
    <div class="filter-date-range-start">
      <i id="startdatepickertrigger" class="material-icons">date_range</i>
      <input type="text" id="start_date_picker" class="filter-date-range-input" name="start_date_picker" v-on:change="setStartDate">
    </div>
    <div class="filter-date-range-thru">thru &nbsp;</div>
    <div class="filter-date-range-end">
      <i id="enddatepickertrigger" class="material-icons">date_range</i>
      <input type="text" id="end_date_picker" class="filter-date-range-input" name="end_date_picker" v-on:change="setEndDate">
      <span class="filter-date-range-error" v-bind:class="[{'s-error': ! isValidEndDate}]">Must be later than first date.</span>
    </div>
  </span>
</template>

<script>
import Pikaday from 'pikaday'
import Moment from 'moment'

export default {
  name: 'filterDateRange',

  props: {
    'label': '',
    'cssClass': ''
  },

  data: function () {
    return {
      startDatePicker: {},
      endDatePicker: {}
    }
  },

  mounted: function () {
    this.startDatePicker = new Pikaday({
      field: document.getElementById('start_date_picker'),
      format: 'MM/DD/YYYY',
      minDate: new Date(2006, 0, 1),
      maxDate: new Date(2023, 5, 1),
      defaultDate: this.startDate,
      setDefaultDate: true,
      trigger: document.getElementById('startdatepickertrigger')
    })

    this.endDatePicker = new Pikaday({
      field: document.getElementById('end_date_picker'),
      format: 'MM/DD/YYYY',
      minDate: new Date(2006, 0, 1),
      maxDate: new Date(2023, 5, 1),
      defaultDate: this.endDate,
      setDefaultDate: true,
      trigger: document.getElementById('enddatepickertrigger')
    })
  },

  computed: {
    isValidEndDate () {
      return (Moment(this.endDate).isBefore(this.startDate)) ? 0 : 1
    },

    startDate () {
      if (this.$route.params.sd) {
        return Moment(this.$route.params.sd, 'YYYY-MM-DD').toDate()
      }

      return Moment(this.$store.getters['filterDateRange/startDate'], 'YYYY-MM-DD').toDate()
    },

    endDate () {
      if (this.$route.params.ed) {
        return Moment(this.$route.params.ed, 'YYYY-MM-DD').toDate()
      }

      return Moment(this.$store.getters['filterDateRange/endDate'], 'YYYY-MM-DD').toDate()
    }
  },

  methods: {
    setStartDate () {
      if (typeof this.startDatePicker.getMoment !== 'undefined') {
        this.$store.dispatch('filterDateRange/setStartDate', this.startDatePicker.getMoment().format('YYYY-MM-DD'))
      }
    },

    setEndDate () {
      if (typeof this.endDatePicker.getMoment !== 'undefined') {
        this.$store.dispatch('filterDateRange/setEndDate', this.endDatePicker.getMoment().format('YYYY-MM-DD'))
      }
    }
  },

  watch: {
    startDate: function () {
      this.startDatePicker.setDate(this.startDate)
    },

    endDate: function () {
      this.endDatePicker.setDate(this.endDate)
    }
  }
}
</script>

<style lang="scss">
@import "~pikaday/css/pikaday.css";
@import "./src/sass/components/FilterDateRange.scss";
</style>



// WEBPACK FOOTER //
// FilterDateRange.vue?332d2ed3